import { render, staticRenderFns } from "./poetry-content.vue?vue&type=template&id=031b80d4&scoped=true&"
import script from "./poetry-content.vue?vue&type=script&lang=js&"
export * from "./poetry-content.vue?vue&type=script&lang=js&"
import style0 from "./poetry-content.vue?vue&type=style&index=0&id=031b80d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031b80d4",
  null
  
)

export default component.exports